import { getTenantSlug } from './tenant.js';

const storageKey = (name) => `atrux:${getTenantSlug()}:${name}`;

const read = (storage, name) => {
  try {
    return storage.getItem(storageKey(name));
  } catch {
    return null;
  }
};

const write = (storage, name, value) => {
  try {
    storage.setItem(storageKey(name), value);
    return true;
  } catch {
    return false;
  }
};

const remove = (storage, name) => {
  try {
    storage.removeItem(storageKey(name));
    return true;
  } catch {
    return false;
  }
};

const clearTenantStorage = (storage) => {
  try {
    const prefix = `atrux:${getTenantSlug()}:`;
    const keys = [];
    for (let index = 0; index < storage.length; index += 1) {
      const key = storage.key(index);
      if (key?.startsWith(prefix)) keys.push(key);
    }
    keys.forEach((key) => storage.removeItem(key));
  } catch {
    // Storage may be unavailable; callers still continue the local logout flow.
  }
};

export const authStorage = {
  key: storageKey,

  getToken() {
    return read(localStorage, 'token');
  },

  setToken(token) {
    return write(localStorage, 'token', token);
  },

  clearToken() {
    return remove(localStorage, 'token');
  },

  getTwoFactorToken() {
    return read(sessionStorage, '2fa-token');
  },

  setTwoFactorToken(token) {
    return write(sessionStorage, '2fa-token', token);
  },

  clearTwoFactorToken() {
    return remove(sessionStorage, '2fa-token');
  },

  clearSession() {
    clearTenantStorage(localStorage);
    clearTenantStorage(sessionStorage);
  },
};

export { storageKey as tenantStorageKey };
